import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=6aaa2a86&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aaa2a86')) {
      api.createRecord('6aaa2a86', component.options)
    } else {
      api.reload('6aaa2a86', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=6aaa2a86&", function () {
      api.rerender('6aaa2a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dw0iCB8iJy7y/JS/childrenage.vue"
export default component.exports